import { lazy } from 'react'

import { WorkflowSurveysPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import { AvailableModules } from 'generated/featureDefinitions'

import { EngagementContext } from 'modules/engagement/lib/EngagementContext'
import PageLoading from 'modules/layout/components/Page/Loading'

const SurveysListPage = lazy(() => import('modules/surveys/pages/Index/SurveysListPage'))

function WorkflowSurveysPage() {
  const { data, loading } = useQuery(WorkflowSurveysPageDocument)

  const moduleAvailabilities = data?.companies.moduleAvailabilities ?? []
  const surveysModuleAvailable = isModuleAvailabilityEnabled(
    moduleAvailabilities,
    AvailableModules.surveys
  )
  const upsellFlowEnabled = data?.upsell._policies.canRequestUpsell.can ?? false

  const canCreateForms = data?.surveys._policies.createForms.can ?? false
  const canCreateTemplates = data?.surveys._policies.createSurveyTemplates.can ?? false
  const canManageSurveys = data?.surveys._policies.v2ManageSurveys.can ?? false
  const canCreateEverybody = data?.surveys._policies.surveyCreateEverybody.can ?? false
  const canCreateOwned = data?.surveys._policies.surveyCreateOwned.can ?? false
  const canCreateReportees = data?.surveys._policies.surveyCreateReportees.can ?? false
  const canCreateTeam = data?.surveys._policies.surveyCreateTeam.can ?? false
  const canSeeSmartSurveys = data?.surveys._policies.sidebarSeeSmartSurveysSubLevelItem.can ?? false
  const activeEmployeesCount = data?.employees.employeeNamesConnection.totalCount ?? 0

  if (loading) {
    return <PageLoading />
  }

  return (
    <EngagementContext.Provider
      value={{
        moduleAvailabilities,
        // Subscription addon data is not consumed by survey components.
        // Providing safe defaults avoids importing the MobX collection.
        enpsInstalled: false,
        enpsSubscription: undefined,
        surveysInstalled: surveysModuleAvailable,
        surveysSubscription: undefined,
        upsellFlowEnabled,
        loading,
        canCreateForms,
        canCreateTemplates,
        canManageSurveys,
        canCreateEverybody,
        canCreateReportees,
        canCreateTeam,
        canCreateOwned,
        canSeeSmartSurveys,
        activeEmployeesCount,
      }}
    >
      <SurveysListPage />
    </EngagementContext.Provider>
  )
}

export default WorkflowSurveysPage
